import { createGlobalStyle } from 'styled-components';
import accountSettingsStyles from './accountSettingsStyles';
import { mediaBreakpointDown } from './breakpoints';
import buttonStyles from './buttonStyles';
import customStyles from './customStyles';
import formStyles from './formStyles';
import languageSelectStyles from './languageSelectStyles';
import { loginStyles } from './loginStyles';
import modalStyles from './modalStyles';
import { navStyles } from './navStyles';
import { promotionsStyles } from './promotionStyles';
import { registrationStyles } from './registrationStyles';

const GlobalStyles = createGlobalStyle`
  #KambiBC {
    position: relative !important;
    z-index: 2 !important;
    width: calc(100% + ${props => props.theme.spacing.bodyPadding * 2}px) !important;
    right: ${props => props.theme.spacing.bodyPadding}px !important;
    ${mediaBreakpointDown('xl')} {
      width: calc(100% + ${props => props.theme.spacing.bodyPaddingMedium * 2}px) !important;
      right: ${props => props.theme.spacing.bodyPaddingMedium}px !important;
    }
    ${mediaBreakpointDown('lg')} {
      width: calc(100% + ${props => props.theme.spacing.bodyPaddingSmall * 2}px) !important;
      right: ${props => props.theme.spacing.bodyPaddingSmall}px !important;
    }
    &-container {
      overflow-y: hidden !important;
    }
  }
  #mod-KambiBC-betslip-container.mod-KambiBC-betslip-container {
      z-index: 999999 !important;
  }
  // world pay deposit iframe styles
  #fCheckout {
    #eProtect-iframe {
      height: 25vh;
    }
    #submitId {
      background-color: ${props => props.theme.colors.primary.main};
      color: ${props => props.theme.colors.brand.text};
      border: none;
      border-radius: 16px;
      font-weight: 600;
      padding: 0.7rem 1rem;
    }
    table {
      width: 100%;
    }
  }
  .sb-hidden {
    #KambiBC {
      border: 0; 
      clip: rect(0 0 0 0);
      height: 1px;  
      margin: -1px;  
      overflow: hidden;  
      padding: 0;  
      position: absolute;  
      width: 1px;
      display: none;
    }
  }
  ${customStyles}
  ${modalStyles}
  ${buttonStyles}
  ${languageSelectStyles}
  ${loginStyles}
  ${navStyles}
  ${formStyles}
  ${promotionsStyles}
  ${registrationStyles}
  ${accountSettingsStyles}
    
  ::backdrop {
    background-color: ${props => props.theme.backdrop?.bgColor || 'rgba(255, 255, 255, 0.6)'};
  }

  .visually-hidden {
    border: 0;
    clip: rect(0 0 0 0);
    height: auto;
    margin: 0;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
    white-space: nowrap;
  }
  
  body {
      background-color: ${props => props.theme.pageContainer.backgroundColor};
  }
  .custom-alert {
      margin: 0px 0px !important;
  }
  #webpush-notification-center-open.webpush-notification-center-color-light {
      display: none !important;
  }
  
`;
export default GlobalStyles;
